import type { ListingStage } from '@/api/v4/project-listings.api';

export const getListingStageByDefaultName = (
  name: string,
  listingStages: ListingStage[],
) => listingStages.find(stage => stage.name === name);
